module.exports = __webpack_public_path__ + "assets/img/free_30.78555ef6.png";